// External imports
import React, { useEffect } from 'react';
import { Paper, Typography, withStyles } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
// Internal imports
import { fetchAndDispatchRemoteData } from '~/app/Pages/Returns/pages/Signatures/signaturesHelper.js';
import SignatureList from '~/app/Pages/Returns/pages/Signatures/components/SignatureList.jsx';
// Redux imports
import { useSelector } from 'react-redux';
// Styling imports
import '~/app/Pages/Returns/pages/Signatures/css/signatures.css';
import { styles } from '~/app/Pages/Returns/pages/Signatures/css/signatures.js';

/**
 * Parent Component for SignatureList. Displays a read-only view of signature request statuses.
 *
 * @component
 * @category Returns
 * @subcategory Signatures
 */
const Signatures = props => {
  const { classes } = props;
  const { preparerID, amendedPreparerID, returnID } = useSelector(state => ({
    preparerID: state.formViewer.preparerID,
    amendedPreparerID: state.formViewer.amendedPreparerID,
    returnID: state.returnProfile.returnID,
  }));

  useEffect(() => {
    fetchAndDispatchRemoteData(props.efinNumber, preparerID, amendedPreparerID, returnID);
  }, [props.efinNumber, preparerID, amendedPreparerID, returnID]);

  return (
    <div id="taxform" className={classes.archiveDocContainer}>
      <div className={classes.archiveHeder}>
        <Typography className="signatures-typography" variant="h6">
          Signatures
        </Typography>
      </div>
      <Paper elevation={0} className={classes.migrationNotice}>
        <InfoIcon className={classes.migrationNoticeIcon} />
        <Typography className={classes.migrationNoticeText}>
          Remote signature requests are now initiated through the Print menu. Select a document type
          from Print, then choose &apos;Remote Signature&apos; to send a new request. This page
          shows the status of existing requests.
        </Typography>
      </Paper>
      <div className="signatures-signature-list-block">
        <SignatureList
          efinNumber={props.efinNumber}
          printPrefs={props.printPrefs}
          bankID={props.bankID}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(Signatures);
